import { createFileRoute, redirect } from '@tanstack/react-router';

import { getApplicantEmail } from '@/applications/applicant-email';
import { Heading } from '@/common/components/heading';
import { isNullOrWhitespace } from '@/common/string';
import { EnvelopeCircleCheckIcon } from '@/icons/fa/duotone-solid';
import { EmptyState, EmptyStateMessage } from '@/shared/components/empty-states';

export const Route = createFileRoute('/apply/verify-email')({
  component: VerifyEmailRoute,
  beforeLoad: () => {
    const applicantEmail = getApplicantEmail();

    if (isNullOrWhitespace(applicantEmail)) throw redirect({ to: '/apply' });

    return { applicantEmail };
  }
});

function VerifyEmailRoute() {
  const { applicantEmail } = Route.useRouteContext();

  return (
    <div className="p-8 flex flex-col items-center">
      <EmptyState className="max-w-xl">
        <Heading>Confirm your Email</Heading>
        <EnvelopeCircleCheckIcon className="size-20 text-secondary-900/75"/>
        <EmptyStateMessage>
          This process requires an account to continue. We have sent an email to {applicantEmail} with a link to create an account or login.
        </EmptyStateMessage>
      </EmptyState>
    </div>
  );
}
